import React, { ReactNode } from 'react';

import ErrorMessageProviderContext from './contexts/error-message-context';
import useErrorMessageProviderState from './states/error-message-provider-state';

type Props = {
  children: ReactNode;
};

const ErrorMessageProvider = ({ children }: Readonly<Props>): React.JSX.Element => (
  <ErrorMessageProviderContext.Provider value={useErrorMessageProviderState()}>{children}</ErrorMessageProviderContext.Provider>
);

export default ErrorMessageProvider;
